import Form from 'flarum/common/components/Form';
import app from 'flarum/forum/app';
import FormModal from 'flarum/common/components/FormModal';
import Button from 'flarum/common/components/Button';
import Stream from 'flarum/common/utils/Stream';
import extractText from 'flarum/common/utils/extractText';
export default class EditExpModal extends FormModal {
  oninit(vnode) {
    super.oninit(vnode);
    this.exp = Stream(this.attrs.user.data.attributes['exp'] || 0);
  }
  className() {
    return 'EditExpModal Modal--small';
  }
  title() {
    return app.translator.trans('foskym-custom-levels.forum.modal.title', {
      user: this.attrs.user
    });
  }
  content() {
    let expText = app.forum.attribute('foskym-custom-levels.expText') || extractText(app.translator.trans('foskym-custom-levels.lib.defaults.exp'));
    if (expText.indexOf('[expTotal]') > -1) expText = expText.replace('[expTotal]', this.attrs.user.data.attributes['exp']);else expText = this.attrs.user.data.attributes['exp'] + ' ' + expText;
    return m("div", {
      className: "Modal-body"
    }, m(Form, null, m("div", {
      className: "Form-group"
    }, m("label", null, app.translator.trans('foskym-custom-levels.forum.modal.current'), " ", expText), m("input", {
      required: true,
      className: "FormControl",
      type: "number",
      step: "1",
      bidi: this.exp
    })), m("div", {
      className: "Form-group"
    }, Button.component({
      className: 'Button Button--primary',
      type: 'submit',
      loading: this.loading
    }, app.translator.trans('foskym-custom-levels.forum.modal.submit_button')))));
  }
  onsubmit(e) {
    e.preventDefault();
    this.loading = true;
    this.attrs.user.save({
      exp: parseInt(this.exp(), 10) || 0
    }, {
      errorHandler: this.onerror.bind(this)
    }).then(this.hide.bind(this)).catch(() => {
      this.loading = false;
      m.redraw();
    });
  }
}
flarum.reg.add('foskym-custom-levels', 'forum/components/EditExpModal', EditExpModal);